import { styled, Typography } from "@mui/material"
import analysis from "../../../assets/pngs/related-analysis.png"
import { extraColors } from "../../../utils/theme"

const HeaderText = styled(Typography)({
  color: extraColors.medium,
  fontWeight: 600,
})

const InfoContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  background: extraColors.dark5,
  padding: "24px",
  borderRadius: "8px",
  border: `1px solid ${extraColors.disabled}`,
  marginTop: 25,
  minHeight: 300,
})

const AnalysisImg = styled("img")({
  width: "256px",
  height: "200px",
})

const NoData: React.FC = () => {
  return (
    <InfoContainer>
      <AnalysisImg src={analysis} />
      <Typography
        variant="body1Bold"
        style={{ color: extraColors.disabled, marginTop: 10 }}
      >
        No Data Available
      </Typography>
    </InfoContainer>
  )
}

export const RiskDetails: React.FC = () => {
  return (
    <>
      <HeaderText variant="h3Bold">Risk Factors</HeaderText>
      <NoData />
    </>
  )
}
